import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import { BugReport as BugReportIcon } from '@mui/icons-material'
import Header from './Header'
import Sidebar from './Sidebar'
import { UnsavedChangesProvider } from '../../contexts/UnsavedChangesContext'

const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true)

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  return (
    <UnsavedChangesProvider><Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar open={sidebarOpen} />
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Header onToggleSidebar={toggleSidebar} />
        {import.meta.env.VITE_SHOW_TEST_BANNER === 'true' && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 0.75,
              backgroundColor: 'warning.main',
              color: 'warning.contrastText',
            }}
          >
            <BugReportIcon fontSize="small" />
            <Typography variant="body2" fontWeight="bold">
              TESTING ENVIRONMENT — Data entered here is for testing only and does not reflect production.
            </Typography>
          </Box>
        )}
        <Box component="main" sx={{ flexGrow: 1, p: 3, backgroundColor: '#faf9f7', minHeight: 0 }}>
          <Outlet />
        </Box>
      </Box>
    </Box></UnsavedChangesProvider>
  )
}

export default Layout
